export default __webpack_public_path__ + "static/media/empty.d9a52efc.svg";